import { toast } from '../hooks/use-toast';

/**
 * Notification utilities for OPs Dashboard
 * Replaces alert() and confirm() with styled notifications
 */

// Toast notifications
export const showSuccess = (message) => {
  toast({
    title: 'Success',
    description: message,
    className: 'bg-green-50 border-green-200',
    duration: 5000,
  });
};

export const showError = (message) => {
  toast({
    title: 'Error',
    description: message,
    variant: 'destructive',
    duration: 5000,
  });
};

export const showWarning = (message) => {
  toast({
    title: 'Warning',
    description: message,
    className: 'bg-yellow-50 border-yellow-200',
    duration: 5000,
  });
};

export const showInfo = (message) => {
  toast({
    title: 'Info',
    description: message,
    duration: 5000,
  });
};

// Confirmation dialog helper
// Returns a promise that resolves to true/false
export const confirm = (message, title = 'Confirm Action') => {
  return new Promise((resolve) => {
    // Create a custom event to trigger the confirmation dialog
    const event = new CustomEvent('ops-confirm', {
      detail: {
        title,
        message,
        onConfirm: () => resolve(true),
        onCancel: () => resolve(false)
      }
    });
    window.dispatchEvent(event);
  });
};

// Simplified confirm for inline use
export const confirmAction = async (message, onConfirm, onCancel) => {
  const result = await confirm(message);
  if (result && onConfirm) {
    onConfirm();
  } else if (!result && onCancel) {
    onCancel();
  }
  return result;
};
